// extracted by mini-css-extract-plugin
export var footer = "_nw-5";
export var fulfillmentInput = "_nw-0";
export var shipDateInput = "_nw-1";
export var shipmentModal = "_nw-2";
export var shipmentModalContent = "_nw-3";
export var tableContainer = "_nw-4";